import { dropWhile, sum } from './arrayHelpers.js'

export function capitalize(input: string): string {
  if (input.length === 0) {
    return input
  }
  return input.charAt(0).toUpperCase() + input.slice(1)
}

export const getFirstCapitalLetter = (input: string): string => {
  const remainder = dropWhile(input.split(''), (char) => char !== char.toUpperCase() || /\s/.test(char))

  if (remainder.length) {
    return remainder[0]
  }

  return ''
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function isBSN(value: string): boolean {
  const isChecksumValid = (input: string) => {
    const numbers = input.split('').map((char) => parseInt(char, 10))
    const checksum = sum(numbers.map((number, idx) => number * (9 - idx))) - 2 * numbers[8]

    return checksum % 11 === 0
  }

  switch (value.length) {
    case 8:
      return isChecksumValid(`0${value}`)
    case 9:
      return isChecksumValid(value)
    default:
      return false
  }
}

export const toCamelCase = (input: string): string =>
  input.replace(/([-_][a-z])/gi, ($1) => $1.toUpperCase().replace('-', '').replace('_', ''))

export const hashCode = (s: string): number =>
  [...s].map((x) => x.charCodeAt(0)).reduce((acc, x) => Math.imul(31, acc) + x, 0)

export const pascalCaseToCamelCase = (input: string): string => input.charAt(0).toLowerCase() + input.slice(1)
